<template>
  <div
    v-if="!loading"
    class="ma-3"
  >
    <form>
      <v-row>
        <v-col
          cols="4"
          class="ma-3"
        >
          <v-row>
            <v-icon
              v-if="form.suhlas_zvjs_2"
              color="success"
              x-large
            >
              mdi-check
            </v-icon>
            <v-icon
              v-else
              color="error"
              x-large
            >
              mdi-close
            </v-icon>
            <v-file-input
              v-model="suhlas_zvjs_2_file"
              accept=".pdf"
              label="Súhlas ZVJS od 1.10.2023"
            />
          </v-row>

          <v-btn
            v-if="form.suhlas_zvjs_2"
            color="primary"
            @click="downloadItem(form.suhlas_zvjs_2, 'suhlas_zvjs_2')"
            class="mr-2"
          >
            Stiahnuť
          </v-btn>
          <v-btn
            v-if="form.suhlas_zvjs_2"
            color="error"
            :loading="deleting_field === 'suhlas_zvjs_2'"
            :disabled="deleting_field !== null"
            @click="deleteFile('suhlas_zvjs_2')"
          >
            Odstrániť
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="4"
          class="ma-3"
        >
          <v-row>
            <v-icon
              v-if="form.suhlas_zvjs"
              color="success"
              x-large
            >
              mdi-check
            </v-icon>
            <v-icon
              v-else
              color="error"
              x-large
            >
              mdi-close
            </v-icon>
            <v-file-input
              v-model="suhlas_zvjs_file"
              accept=".pdf"
              label="Súhlas ZVJS do 30.9.2023"
            />
          </v-row>

          <v-btn
            v-if="form.suhlas_zvjs"
            color="primary"
            @click="downloadItem(form.suhlas_zvjs, 'suhlas_zvjs')"
            class="mr-2"
          >
            Stiahnuť
          </v-btn>
          <v-btn
            v-if="form.suhlas_zvjs"
            color="error"
            :loading="deleting_field === 'suhlas_zvjs'"
            :disabled="deleting_field !== null"
            @click="deleteFile('suhlas_zvjs')"
          >
            Odstrániť
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="4"
          class="ma-3"
        >
          <v-row>
            <v-icon
              v-if="form.cv"
              color="success"
              x-large
            >
              mdi-check
            </v-icon>
            <v-icon
              v-else
              color="error"
              x-large
            >
              mdi-close
            </v-icon>

            <v-file-input
              v-model="cv_file"
              accept=".pdf"
              label="CV"
            />
          </v-row>

          <v-btn
            v-if="form.cv"
            color="primary"
            @click="
              downloadItem(form.cv, 'cv')
            "
            class="mr-2"
          >
            Stiahnuť
          </v-btn>
          <v-btn
            v-if="form.cv"
            color="error"
            :loading="deleting_field === 'cv'"
            :disabled="deleting_field !== null"
            @click="deleteFile('cv')"
          >
            Odstrániť
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="4"
          class="ma-3"
        >
          <v-row>
            <v-icon
              v-if="form.suhlas_zmos"
              color="success"
              x-large
            >
              mdi-check
            </v-icon>
            <v-icon
              v-else
              color="error"
              x-large
            >
              mdi-close
            </v-icon>
            <v-file-input
              v-model="suhlas_zmos_file"
              accept=".pdf"
              label="Súhlas ZMOS"
            />
          </v-row>

          <v-btn
            v-if="form.suhlas_zmos"
            color="primary"
            @click="downloadItem(form.suhlas_zmos, 'suhlas_zmos')"
            class="mr-2"
          >
            Stiahnuť
          </v-btn>
          <v-btn
            v-if="form.suhlas_zmos"
            color="error"
            :loading="deleting_field === 'suhlas_zmos'"
            :disabled="deleting_field !== null"
            @click="deleteFile('suhlas_zmos')"
          >
            Odstrániť
          </v-btn>
        </v-col>
      </v-row>

      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <div
          v-if="uploading"
          class="text-center"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </div>
        <v-btn
          class="ma-2"
          fixed
          right
          bottom
          dark
          rounded
          color="primary"
          @click="updateItem()"
        >
          Uložiť
        </v-btn>
      </v-layout>
    </form>

    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>
  </div>

  <div v-else>
    <form-skeleton-component skeleton_type="Swot" />
  </div>
</template>

<script>
import { APIService } from "@/http/APIService.js";
import FormSkeleton from "../components/FormSkeleton.vue";
import axios from "axios";

const apiService = new APIService();

export default {
  $_veeValidate: {
    validator: "new",
  },

  components: {
    "form-skeleton-component": FormSkeleton,
  },

  data: () => ({
    loading: false,
    snackbar_saved: false,
    snackbar_error: false,
    uploading: false,
    deleting_field: null,

    suhlas_zvjs_file: null,
    suhlas_zvjs_2_file: null,
    cv_file: null,
    suhlas_zmos_file: null,


    form: {
      id: null,
      suhlas_zvjs: null,
      suhlas_zvjs_2: null,
      cv: null,
      suhlas_zmos: null,
    }
  }),

  computed: {},

  mounted() {
    this.getItem();
  },

  methods: {
    getItem() {
      this.loading = true;
      apiService.getIapszDokumenty(this.$route.params.id).then((response) => {
        this.form = response;
        this.loading = false;
      });
    },


    updateItem() {
      this.uploading = true;

      let formData = new FormData();

      for (var key in this.form) {
        if (
          key == "suhlas_zvjs" ||
          key == "cv" ||
          key == "suhlas_zmos" ||
          key == "suhlas_zvjs_2"
        )
          continue;

        if (this.form[key] != null) formData.set(key, this.form[key]);
      }

      if (this.form.suhlas_zvjs == null) formData.append("suhlas_zvjs", "");

      if (this.form.suhlas_zvjs_2 == null) formData.append("suhlas_zvjs_2", "");


      if (this.form.cv == null) formData.append("cv", "");

      if (this.form.suhlas_zmos == null) formData.append("suhlas_zmos", "");


      if (this.suhlas_zvjs_file instanceof File)
        formData.append("suhlas_zvjs", this.suhlas_zvjs_file);

        if (this.suhlas_zvjs_2_file instanceof File)
        formData.append("suhlas_zvjs_2", this.suhlas_zvjs_2_file);


      if (this.cv_file instanceof File)
        formData.append("cv", this.cv_file);

      if (this.suhlas_zmos_file instanceof File)
        formData.append("suhlas_zmos", this.suhlas_zmos_file);

      apiService.updateIapszDokumenty(formData, this.$route.params.id, this.form.id).then(
        (response) => {
          this.uploading = false;
          this.snackbar_saved = true;
          this.form = response;
        },
        () => {
          this.uploading = false;
          this.snackbar_error = true;
        }
      );
    },

    downloadItem(url, typeItem) {
      var oldThis = this;
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "iapsz_" + oldThis.$route.params.id + "_" + typeItem + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(
          (error) => {
            oldThis.snackbar_error = true;
          });
    },

    deleteFile(fieldName) {
      if (!confirm(`Naozaj chcete odstrániť tento súbor?`)) {
        return;
      }

      this.deleting_field = fieldName;

      apiService.deleteIapszDokumentyFile(
        this.$route.params.id,
        this.form.id,
        fieldName
      ).then(
        () => {
          this.deleting_field = null;
          this.snackbar_saved = true;
          this.getItem();
        },
        (error) => {
          this.deleting_field = null;
          this.snackbar_error = true;
        }
      );
    },

  },
};
</script>